<template>
  <v-container>
    <ContainerPicker
      v-model="value.container"
      title="Dialog"
      :containers="containers"
      type="Dialog"
      :is-required="true"
    />
  </v-container>
</template>

<script>
import ContainerPicker from "../shared/ContainerPicker.vue";

export default {
  name: "HideDesigner",

  components: { ContainerPicker },

  props: ["value", "containers"],
};
</script>
